/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { parseObject, isFeatureAvailable } from 'shared/helpers';
import { initialPortalData, platformFeatures } from 'shared/constants';
import { fetchCustomerAccounts } from 'customerAccounts/actions';
import { ProfileNavigation, LanguageSwitcher } from './components';
import './styles.scss';
import CustomerAccountSelector from 'customerAccounts/CustomerAccountSelector';

const Header = ({ children }) => {
  const dispatch = useDispatch();
  const userCompanyData = useSelector((state) => get(state, 'user.company'));
  const customerAccounts = useSelector((state) =>
    get(state, 'account.customerAccounts', []),
  );
  const accountsLoading = useSelector((state) => get(state, 'account.loading'));
  const accountsError = useSelector((state) => get(state, 'account.error'));
  const accountsFetched = useSelector((state) =>
    get(state, 'account.fetched', false),
  );
  const { logo, name, portal_data } = userCompanyData;
  const portalData = parseObject(portal_data, initialPortalData);
  const firstCharCompanyName = get(name, '[0]', '');
  const headerBackground = get(portalData, 'topHeaderBackground', '#555555');
  const hasAccountFeature = isFeatureAvailable(
    platformFeatures.extra_account_based_licensing,
  );
  const hasCustomerAccounts = customerAccounts.length > 0;

  useEffect(() => {
    if (
      hasAccountFeature &&
      !hasCustomerAccounts &&
      !accountsLoading &&
      !accountsError &&
      !accountsFetched
    ) {
      dispatch(fetchCustomerAccounts());
    }
  }, [
    dispatch,
    hasAccountFeature,
    hasCustomerAccounts,
    accountsLoading,
    accountsError,
    accountsFetched,
  ]);

  return (
    <header className="Header" style={{ background: headerBackground }}>
      <div className="Header-primary">
        <div className="logo">
          <NavLink to="/">
            {logo ? (
              <img src={logo} alt="company logo" className="company-logo" />
            ) : (
              <div className="company-logo-placeholder">
                {firstCharCompanyName.toUpperCase()}
              </div>
            )}
            <span className="company-name">{name}</span>
          </NavLink>
        </div>
        {hasAccountFeature && (accountsLoading || hasCustomerAccounts) && (
          <CustomerAccountSelector />
        )}
        {children}
      </div>
      <div className="Header-secondary">
        <LanguageSwitcher />
        <ProfileNavigation />
      </div>
    </header>
  );
};

Header.propTypes = {
  children: PropTypes.element,
};

Header.defaultProps = {
  children: <div />,
};

export default Header;
